<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Военная составляющая игры / Противостояние между союзами (Дуэли)</h3>
		</header>
		<p>...</p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisWars2',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>